import {
  EAssetType,
  MediaSequenceAssetMutationCreateRequest,
  MediaSequenceAssetMutationUpdateRequest,
  MediaSequenceAssetResponse,
} from 'api/core';
import { VolumePicker } from 'components/Form/VolumePicker';
import { VideoPreviewWithTrim } from 'components/Video/VideoPreviewWithTrim';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

const PLAYBACK_SPEED_MIN = 0.5;
const PLAYBACK_SPEED_MAX = 4;
const PLAYBACK_SPEED_STEP = 0.1;
const PLAYBACK_SPEED_TICK_PER = 0.5;

interface PlaybackAdjustmentsProps {
  asset: MediaSequenceAssetResponse;
}

export const PlaybackAdjustments = ({ asset }: PlaybackAdjustmentsProps) => {
  const { register, watch, setValue } = useFormContext<
    | MediaSequenceAssetMutationCreateRequest
    | MediaSequenceAssetMutationUpdateRequest
  >();

  const assetTrimMutation = asset.mutations.find(
    (e) => e.trimVideo !== undefined
  )?.trimVideo;

  return (
    <>
      <VolumePicker
        registerFn={() =>
          register('playback.speed', {
            required: true,
          })
        }
        watchFn={() => watch('playback.speed') || 1}
        setFn={(value: number) => setValue('playback.speed', value)}
        min={PLAYBACK_SPEED_MIN}
        max={PLAYBACK_SPEED_MAX}
        step={PLAYBACK_SPEED_STEP}
        defaultVolume={1}
        showZeroStep={false}
        showCurrentValueInTop={false}
        tickRenderer={(val) => {
          if (val % PLAYBACK_SPEED_TICK_PER !== 0) return '';

          const currentPlaybackSpeed = watch('playback.speed');
          const isValueEqualToCurrent = currentPlaybackSpeed == val;

          return (
            <span
              className={twMerge(
                'text-primary transition-colors duration-300',
                isValueEqualToCurrent && 'font-bold'
              )}
            >
              {val}x
            </span>
          );
        }}
        maxVolumeLabel="Original"
        label={`Afspilningshastighed ${watch('playback.speed') != 1 ? `(${watch('playback.speed')}x)` : ''}`}
      />

      <div className="form-control items-start">
        <label className="cursor-pointer label">
          <span className="label-text me-2">Afspil baglæns</span>
          <input
            {...register('playback.reverse')}
            type="checkbox"
            className="toggle toggle-primary"
          />
        </label>
      </div>

      {asset.asset.type === EAssetType.Video ? (
        <>
          <VideoPreviewWithTrim
            asset={asset.asset}
            className="w-full h-48 object-contain"
            loop
            muted
            trimStart={assetTrimMutation?.trimStartSeconds}
            trimEnd={assetTrimMutation?.trimEndSeconds}
            playbackSpeed={watch('playback.speed') || 1}
          />
        </>
      ) : null}
    </>
  );
};
